/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：メニューコンフィグレーション
 *
 * 作成者：2021/11/24 ノア）虞
 * 最終修正者：2021/11/29 ノア）虞
 *
 */
import { MenuMasterItem } from '@/models'
import { i18n } from '@/locales'
import { localService } from '@/commons/services/localService'

/**
 * メニュー
 *
 * @returns {Record<string, MenuMasterItem[]>} メニュー
 */
// eslint-disable-next-line max-lines-per-function
export function getMenuMasterConfig(): Record<string, MenuMasterItem[]> {
  return {
    menuMaster: [
      { code: 'screenList', value: i18n.t('menu.screens').toString(), tip: i18n.t('menu.screensTip').toString() },
      { code: 'dynamicMap', value: i18n.t('menu.dynamicMap').toString(), tip: i18n.t('menu.dynamicMapTip').toString() },
      {
        code: 'managementList',
        value: i18n.t('menu.managementList', [localService.userInfo?.managementTargetShowName]).toString(),
        tip: i18n.t('menu.managementListTip', [localService.userInfo?.managementTargetShowName]).toString()
      },
      {
        code: 'historyManagement',
        value: i18n.t('menu.historyManagement').toString(),
        tip: i18n.t('menu.historyManagementTip', [localService.userInfo?.managementTargetShowName]).toString()
      },
      {
        code: 'analysisByBusinessOffices',
        value: i18n.t('menu.analysisByBusinessOffices').toString(),
        tip: i18n.t('menu.analysisByBusinessOfficesTip', [localService.userInfo?.managementTargetShowName]).toString()
      },
      {
        code: 'areaAnalysis',
        value: i18n.t('menu.areaAnalysis').toString(),
        tip: i18n.t('menu.areaAnalysisTip', [localService.userInfo?.managementTargetShowName]).toString()
      },
      {
        code: 'subjectMaster',
        value: i18n.t('menu.subjectMaster', [localService.userInfo?.managementTargetShowName]).toString(),
        tip: i18n.t('menu.subjectMasterTip', [localService.userInfo?.managementTargetShowName]).toString()
      },
      {
        code: 'subjectMasterAllocation',
        value: i18n.t('menu.subjectMasterAllocation', [localService.userInfo?.managementTargetShowName]).toString(),
        tip: i18n.t('menu.subjectMasterAllocationTip', [localService.userInfo?.managementTargetShowName]).toString()
      },
      {
        code: 'headMaster',
        value: i18n.t('menu.headMaster').toString(),
        tip: i18n.t('menu.headMasterTip').toString()
      },
      {
        code: 'gpsTrackeraster',
        value: i18n.t('menu.gpsTrackeraster').toString(),
        tip: i18n.t('menu.gpsTrackerasterTip').toString()
      },
      {
        code: 'managementLocationMaster',
        value: i18n.t('menu.managementLocationMaster').toString(),
        tip: i18n.t('menu.managementLocationMasterTip').toString()
      },
      {
        code: 'managementLocationDetailMaster',
        value: i18n.t('menu.managementLocationDetailMaster').toString(),
        tip: i18n.t('menu.managementLocationDetailMasterTip').toString()
      },
      {
        code: 'businessOfficeMaster',
        value: i18n.t('menu.businessOfficeMaster').toString(),
        tip: i18n.t('menu.businessOfficeMasterTip').toString()
      },
      {
        code: 'businessOfficeAllocation',
        value: i18n.t('menu.businessOfficeAllocation').toString(),
        tip: i18n.t('menu.businessOfficeAllocationTip').toString()
      },
      {
        code: 'userMaster',
        value: i18n.t('menu.userMaster').toString(),
        tip: i18n.t('menu.userMasterTip').toString()
      },
      {
        code: 'areaMaster',
        value: i18n.t('menu.areaMaster').toString(),
        tip: i18n.t('menu.areaMasterTip').toString()
      },
      {
        code: 'areaAllocation',
        value: i18n.t('menu.prefAllocMaster').toString(),
        tip: i18n.t('menu.prefAllocMasterTip').toString()
      },
      {
        code: 'gpsTrackerTerminalConfig',
        value: i18n.t('menu.gpsTrackerTerminalConfig').toString(),
        tip: i18n.t('menu.gpsTrackerTerminalConfigTip').toString()
      },
      {
        code: 'corporateManagement',
        value: i18n.t('menu.corporateManagement').toString(),
        tip: i18n.t('menu.corporateManagementTip').toString()
      },
      {
        code: 'alertList',
        value: i18n.t('menu.alertList').toString(),
        tip: i18n.t('menu.alertListTip').toString()
      },
      {
        code: 'gpsTrackerExchange',
        value: i18n.t('menu.gpsTrackerExchange').toString(),
        tip: i18n.t('menu.gpsTrackerExchangeTip').toString()
      }
    ]
  }
}
